import { l, BonusTypesLabels } from 'constants/common';

const DataTableColumnsConfigs = (t, type) => {
    const minMaxLabels = [
        BonusTypesLabels.NftVoucherBonus,
        BonusTypesLabels.WonderWheelSpin,
        BonusTypesLabels.FreeSpin,
        BonusTypesLabels.LoyaltyPoint,
    ].includes(type)
        ? { min: l.MinCount, max: l.MaxCount }
        : { min: l.MinAmount, max: l.MaxAmount };

    return {
        columns: [
            {
                text: t(l.Currency),
                dataKey: 'CurrencyCode',
                sortable: false,
            },
            {
                text: t(minMaxLabels.min),
                dataKey: 'MinAmount',
                sortable: false,
            },

            {
                text: t(minMaxLabels.max),
                dataKey: 'MaxAmount',
                sortable: false,
            },
        ],
    };
};

export { DataTableColumnsConfigs };
